import React from 'react';
import { useQuery } from 'react-apollo';
import { Select } from 'antd';
import gql from 'graphql-tag';

const UNIQUE_PLAYBOOK_LABELS_QUERY = gql`
  query UniquePlaybookLabels {
    uniquePlaybookLabels
  }
`;
// LABELS FILTER
interface PlaybookLabelsFilterProps {
  value?: string[] | null;
  onChange: (value: string[]) => void;
}

function PlaybookLabelsFilter(props: PlaybookLabelsFilterProps) {
  const { value, onChange } = props;

  const { loading, data } = useQuery(UNIQUE_PLAYBOOK_LABELS_QUERY);

  return (
    <Select
      mode="multiple"
      value={value || undefined}
      style={{ minWidth: '200px', maxWidth: '500px' }}
      onChange={onChange}
      dropdownMatchSelectWidth={false}
      placeholder={'Select label(s)'}
      maxTagCount={2}
      maxTagTextLength={48}
      maxTagPlaceholder={(extraValues) => {
        return <>+&nbsp;{extraValues.length}</>;
      }}
      loading={loading}
    >
      {!loading &&
        data &&
        data.uniquePlaybookLabels &&
        data.uniquePlaybookLabels.map((o, idx) => {
          return (
            <Select.Option key={`${o}_${idx}`} value={o}>
              {o}
            </Select.Option>
          );
        })}
    </Select>
  );
}

export default PlaybookLabelsFilter;
